import {
  CompleteVehicleEntry,
  DynamicFinancingValues,
  FootnoteReference,
  PriceItem,
  SharedChangeRateLink,
} from '@oneaudi/vtp-shared';
import React from 'react';
import { RateContainer, RateDetailWrapper } from '../styles/ConversionBar.styles';
import { Text } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';

interface DisplayConversionbarRateProps {
  vehicleRaw: CompleteVehicleEntry;
  dynamicFinancingValues?: DynamicFinancingValues;
  updateDynamicFinancingValues?: (values?: DynamicFinancingValues) => void;
  financeEnabled: boolean;
  staticRateConfig: PriceItem;
}

export const DisplayConversionbarRate: React.FC<DisplayConversionbarRateProps> = ({
  vehicleRaw,
  dynamicFinancingValues,
  updateDynamicFinancingValues,
  financeEnabled,
  staticRateConfig,
}) => {
  const vehicleBasic = vehicleRaw.basic;

  const perMonthLabel = useI18n({ id: 'stockcars.financing.permonth', defaultMessage: '' });

  let rateToBeRendered = staticRateConfig?.price;

  if (vehicleBasic.financing) {
    rateToBeRendered = dynamicFinancingValues ? dynamicFinancingValues.rate : rateToBeRendered;
  }

  if (!financeEnabled || !rateToBeRendered) {
    return null;
  }
  return (
    <RateDetailWrapper data-testid="display-rateWrapper">
      <RateContainer>
        <Text tag="span" variant={{ type: 'copy', order: '1', style: 'bold' }}>
          {rateToBeRendered}&nbsp;
          {perMonthLabel}
          {staticRateConfig?.priceFootnote && (
            <FootnoteReference refId={staticRateConfig?.priceFootnote} />
          )}
        </Text>
      </RateContainer>
      {dynamicFinancingValues && (
        <SharedChangeRateLink
          vehicle={vehicleRaw}
          dynamicFinancingValues={dynamicFinancingValues}
          updateDynamicFinancingValues={updateDynamicFinancingValues}
        />
      )}
    </RateDetailWrapper>
  );
};
